const StorageDomain =
  "https://thtlajzibybayogrvjsd.supabase.co/storage/v1/object/public/nikolay/styles/";

export const colorMap: Record<string, string> = {
  White: "#FFFFFF",
  Black: "#000000",
  BalletPink: "#F9C7D5",
  DustyPink: "#cd8ea9",
  OrchidMist: "#9c89b6",
  Beige: "#c8a487",
  Tan: "#D2B48C",
  DarkNude: "#AF7C6B",
  Red: "#F61F1F",
  Ivory: "#FFFFF0",
  Pink: "#FFC0CB",
  Cherry: "#DE3163",
  TheatricalPink: "#EECECC",
  ClassicLightToast: "#D4B7A0",
  LightToast: "#F6D5A9",
  Cyclamen: "#F56FA1",
  Burgundy: "#800020",
  Nude: "#e2ba96",
  Gold: "#FFD700",
  Cream: "#faf8e9",
  Sand: "#C2B280",
  PeachChampagne: "#F7CDA9",
  Salmon: "#FA8072",
  LightPink: "#FFB6C1",
  Orange: "#FFA500",
  Lemon: "#FFF700",
  PistachioGreen: "#93C572",
  Green: "#008000",
  Olive: "#6f877a",
  OceanBlue: "#4F42B5",
  Teal: "#008080",
  Sky: "#87CEEB",
  ArcticBlue: "#B2FFFF",
  Azure: "#007FFF",
  RoyalBlue: "#4169E1",
  Marine: "#3B9C9C",
  Violet: "#8A2BE2",
  Lilac: "#cdcfe5",
  IcyLavendere: "#E0BBE4",
  TileBeige: "#D9B382",
  Brown: "#964B00",
  Grey: "#bebfc4",
  DarkGrey: "#4c535f",
  DarkBlue: "#243151",
  CornflowerBlue: "#6867a8",
  LimeNeon: "#BFFF00",
  GreenNeon: "#39FF14",
  FuchsiaNeon: "#FF00FF",
  OrangeNeon: "#FF5F1F",
  Seta: "#DDD1C7",
  OffWhite: "#FAF9F6",
  SilkWhite: "#F8F8F0",
  Champagne: "#F7E7CE",
  BriarRose: "#C72C48",
  Orchid: "#DA70D6",
  SealingWax: "#AA0114",
  VictoriaRose: "#F572A4",
  Powder: "#F2E9E4",
  Laguna: "#234d57",
  Peacock: "#1D616A",
  EpireBlue: "#3B6BA5",
  FrenchNavy: "#171C3A",
  Purple: "#A54DCF",
  Poppy: "#f72d35",
  Wine: "#722F37",
  Enamal: "#D1D2D3",
  MintGreen: "#98FF98",
  FlameOrange: "#FF7300",
  Salad: "#A9D39E",
  Hibiscus: "#B43757",
  Hunter: "#05AA3D",
  HotPink: "#FF69B4",
  Grenadier: "#DA291C",
  ToastedAlmond: "#D2B49C",
  Peat: "#71655B",
  MoonStone: "#3AA8C1",
  SilverStar: "#C0C0C0",
  Silver: "#7a7a7a",
  NavySnowflakes: "#001F54",
  SkyBlueSnowflakes: "#87CEEB",
  KellyGreen: "#4CBB17",
  ForestGreen: "#228B22",
  SilverGrey: "#C0C0C0",
  Citronelle: "#E4D96F",
  FloLemon: "#DFFF00",
  FloGold: "#FFD700",
  FloGreen: "#00FF00",
  FloBaize: "#7FFF00",
  FloBlue: "#00BFFF",
  FloRose: "#FF66CC",
  FloCerise: "#DE3163",
  FloPink: "#FF69B4",
  SkyBlue: "#87CEEB",
  Coffee: "#98847a",
  LightBlue: "#D8F1FF",
  ButterPopcorn: "#FCE5A2",
  StarryMidnight: "#0B0C3D",
  GreyMelange: "#55454f",
  CoolPink: "#F6A6B2",
  FrostySunset: "#FACBAA",
  PaleGold: "#E6BE8A",
  ArcticSky: "#B3DDED",
  Aqua: "#00FFFF",
  IceCap: "#E0F7FA",
  StoneSilver: "#B0B0B0",
  Moonstone: "#3AA8C1",
  Blue: "#2d3c91",
  IceBlue: "#2dd2e8",
  Tiffany: "#92cfd0",
  MediumTaupe: "#55454f",
  FrenchBlue: "#0f8ccb",
  LightNavy: "#272660",
  Lavender: "#674b91",
  Bordeaux: "#96236c",
  TeaRosa: "#d4a6ac",
  Illusion: "#755363",
  Mirtillo: "#543044",
  Navy: "#000080",
  RosaAntico: "#f5aeac",
  Gray: "#808080",
  Khaki: "#F0E68C",
  FloralPrint: "#B0BCD6",
  Malachite: "#387b77",
  Reflector: "#D9D9D9",
  Opal: "#A8C3BC",
  Periwinkle: "#CCCCFF",
  CosmicBlue: "#2E3A87",
  Pearl: "#F8F6F0",
  SteelBlue: "#4682B4",
  BlackVelvet: "#101010",
  OpalLeopard: "#B5A27F",
  SlateBlue: "#6A5ACD",
  Venus: "#E3D3E4",
  Iris: "#5A4FCF",
  Comet: "#5C5D75",
  Onyx: "#353839",
  StellarGlow: "#A3E3ED",
  CosmicInk: "#252440",
  BlackStar: "#0A0A23",
  Lips: "#e66b70",
  Etabeta: "#fff74a",
  Cristallo: "#a6dbed",
  CosmicBlack: "#121212",
  BlueberryCheesecake: "#5A4E8C",
  LavenderSwirl: "#B497BD",
  Pistachio: "#93C572",
  SNOW1: "#2f6abf",
  Poseydon: "#FFFFFF",
  GrapeShake: "#F8CBCB",
  NavyHeather: "#282099",
  SNOW2: "#505674",
  SugarPlum: "#914E75",
  Blush: "#F9C2C0",
  SeaShellPink: "#FFF5F3",
  Obsidian: "#0B0B0B",
  Sage: "#CDE4C2",
  VintageGold: "#C5A253",
  Chamomile: "#F0E6A0",
  Stars: "#FFFFFF",
  BlueFloral: "#2B8CF0",
  MotherOfPearl: "#7e708a",
  GreyBlue: "#6699CC",
  ArtDeco: "#2f2f2f",
  Alchemy: "#007883",
  Survivor: "#464037",
  PowderBlue: "#B0E0E6",
  Giza: "#9e7040",
  Roulette: "#4e2529",
  MidnightSky: "#0a004d",
  Ramo: "#574a42",
  Pony: "#f2a1c5",
  PaleBeige: "#d2b996",
  BlackMesh: "#131313",
  Blonde: "#e6d3bc",
  LightBrown: "#a08576",
  MediumBrown: "#81604d",
  DarkBrown: "#57463e",
  YellowClearCrystal: "#f7d00e",
  Peach: "#FFE5B4",
  Chameleon: "#7b7b34",
  Rose: "#ff007f",
  Auburn: "#71231D",
  Mystique: "#64B9E0",
  DarkPink: "#FF1493",
  EuroPink: "#F4A6C0",
  NeonLime: "#39FF14",
  NeonYellow: "#FFFF33",
  NeonOrange: "#FF6700",
  BabyBlue: "#89CFF0",
  Cocoa: "#D2691E",
  DeepBlue: "#0f75a6",
  Pewter: "#99AABB",
  Scarlet: "#FF2400",
  TaffyPink: "#FA86C4",
  Plaisir: "#f2c08f",
  Pebble: "#acb4b1",
  WonderBlue: "#8EA9CC",
  Copper: "#b87333",
  Liana: "#b2aaa7",
  DarkSide: "#004444",
  WavyBlack: "#2f3234",
  WavyDarkSilver: "#979394",
  WavyBlueSteel: "#3a5571",
  WavyOldGold: "#b9a698",
  DarkReflector: "#4e5e6b",
  Reflector1: "#939ea9",
  MetallicMystique: "#4e798a",
  MetallicGreen: "#5dbc97",
  MetallicLilac: "#e7deef",
  MetallicPurple: "#9071b0",
  MetallicNavy: "#333457",
  MetallicPoppy: "#b6353f",
  Angels: `${StorageDomain}Angels.webp`,
  Baroque: `${StorageDomain}Baroque.webp`,
  FractalPurple: `${StorageDomain}FractalPurple.webp`,
  FractalAzure: `${StorageDomain}FractalAzure.webp`,
  Fractals: `${StorageDomain}Fractals.webp`,
  Fractal: `${StorageDomain}Fractal.webp`,
  MUCHA1: `${StorageDomain}MUCHA1.webp`,
  Cat: `${StorageDomain}Cat.webp`,
  Ornament: `${StorageDomain}Ornament.webp`,
  WhiteFlowers: `${StorageDomain}WhiteFlowers.webp`,
  Graphics: `${StorageDomain}Graphics.webp`,
  VioletFlowers: `${StorageDomain}VioletFlowers.webp`,
  Apple: `${StorageDomain}Apple.webp`,
  Raspberry: `${StorageDomain}Raspberry.webp`,
  Flowers: `${StorageDomain}Flowers.webp`,
  Lines: `${StorageDomain}Lines.webp`,
  VRUBEL1: `${StorageDomain}VRUBEL-1.webp`,
  Camellia: `${StorageDomain}Camellia.webp`,
  BlossomingGarden: `${StorageDomain}BlossomingGarden.webp`,
  BlueFloralPrint:`${StorageDomain}BlueFloralPrint.webp`
};

export const colorDoubleMap: Record<string, string[]> = {
  BaroqueIllusion: [colorMap.Baroque, colorMap.Illusion],
  BaroqueLaguna: [colorMap.Baroque, colorMap.Laguna],
  BaroqueBlack: [colorMap.Baroque, colorMap.Black],
  FrenchBlueBlack: [colorMap.FrenchBlue, colorMap.Black],
  GreyGrey: [colorMap.Grey, colorMap.Grey],
  LightNavyNavy: [colorMap.LightNavy, colorMap.Navy],
  BlackRaspberry: [colorMap.Black, colorMap.Raspberry],
  BlackBlack: [colorMap.Black, colorMap.Black],
  BlackChamomile: [colorMap.Black, colorMap.Chamomile],
  BlackStars: [colorMap.Black, colorMap.Stars],
  
  BlackBeige: [colorMap.Black, colorMap.Beige],
  BlackWhite: [colorMap.Black, colorMap.White],
  RoulettePink: [colorMap.Roulette, colorMap.Pink],
  RamoBlack: [colorMap.Ramo, colorMap.Black],
  DarkGreyTiffany: [colorMap.DarkGrey, colorMap.Tiffany],
  DarkGreyLips: [colorMap.DarkGrey, colorMap.Lips],
  DarkGreyPony: [colorMap.DarkGrey, colorMap.Pony],
  DarkGreyLavender: [colorMap.DarkGrey, colorMap.Lavender],

  OliveBlack: [colorMap.Olive, colorMap.Black],
  WhiteBeige: [colorMap.White, colorMap.Beige],

  PowderFlowers: [colorMap.Powder, colorMap.Flowers],
  TiffanyFlowers: [colorMap.Tiffany, colorMap.Flowers],
  BlackFlowers: [colorMap.Black, colorMap.Flowers],

  CamelliaLilac: [colorMap.Camellia, colorMap.Lilac],
  CamelliaMediumTaup: [colorMap.Camellia, colorMap.MediumTaup],

  RedPearls: [colorMap.Red, colorMap.Pearls],
  DarkBlueApple: [colorMap.DarkBlue, colorMap.Apple],
  LightNavyBlack: [colorMap.LightNavy, colorMap.Black],

  BlackMalachite: [colorMap.Black, colorMap.Beige],
  BlackMotherOfPearl: [colorMap.Black, colorMap.MotherOfPearl],
  BlackDarkBlue: [colorMap.Black, colorMap.DarkBlue],
  BlackPoppy: [colorMap.Black, colorMap.Poppy],
  WhiteBlack: [colorMap.White, colorMap.Black],

  GraphicsArtDeco: [colorMap.Graphics, colorMap.Azure],
  GraphicsOlive: [colorMap.Graphics, colorMap.Olive],
  GraphicsBlack: [colorMap.Graphics, colorMap.Black],

  GreyBlueGrey: [colorMap.GreyBlue, colorMap.Grey],
  BlackNavy: [colorMap.Black, colorMap.Navy],

  BordeauxGold: [colorMap.Bordeaux, colorMap.Gold],
  GreySilver: [colorMap.Grey, colorMap.Silver],
  BlueSilver: [colorMap.Blue, colorMap.Silver],
  BlackSilver: [colorMap.Black, colorMap.Silver],

  RedBlack: [colorMap.Red, colorMap.Black],

  BlackAlchemy: [colorMap.Black, colorMap.Alchemy],

  BlackGiza: [colorMap.Black, colorMap.Giza],

  FlowersBlack: [colorMap.Flowers, colorMap.Black],

  BlackPowderBlue: [colorMap.Flowers, colorMap.PowderBlue],

  FlowersGreyGreen: [colorMap.Flowers, colorMap.Grey, colorMap.Green],
  FlowersCopperGrey: [colorMap.Flowers, colorMap.Copper, colorMap.Grey],
  FlowersCopperBlack: [colorMap.Flowers, colorMap.Copper, colorMap.Black],

  FlowersGreyBlack: [colorMap.Flowers, colorMap.Grey, colorMap.Black],

  FlowersIllusion: [colorMap.Flowers, colorMap.Illusion],
  FlowersAlchemy: [colorMap.Flowers, colorMap.Alchemy],
  FlowersPebble: [colorMap.Flowers, colorMap.Pebble],

  EtabetaCristallo: [colorMap.Etabeta, colorMap.Cristallo],

  PlaisirCristallo: [colorMap.Plaisir, colorMap.Cristallo],
  LipsCristallo: [colorMap.Lips, colorMap.Cristallo],
  PonyCristallo: [colorMap.Pony, colorMap.Cristallo],

  BlackMeshTiffany: [colorMap.BlackMesh, colorMap.Tiffany],
  BlackMeshLilac: [colorMap.BlackMesh, colorMap.Lilac],
  BlackMeshPoppy: [colorMap.BlackMesh, colorMap.Poppy],

  BordeauxBeige: [colorMap.Bordeaux, colorMap.Beige],
  LightNavyBeige: [colorMap.LightNavy, colorMap.Beige],
  GreyBeige: [colorMap.Grey, colorMap.Beige],

  LavenderWhite: [colorMap.Lavender, colorMap.White],

  PonyLavander: [colorMap.Pony, colorMap.Lavander],

  BlackOlive: [colorMap.Black, colorMap.Olive],
  BlackBordeaux: [colorMap.Black, colorMap.Bordeaux],
  BlackLightNavy: [colorMap.Black, colorMap.LightNavy],

  TiffanyLips: [colorMap.Tiffany, colorMap.Lips],
  PonyLavender: [colorMap.Pony, colorMap.Lavender],
  GreyBlack: [colorMap.Grey, colorMap.Black],
  BlackGrey: [colorMap.Black, colorMap.Grey],

  BlackLipsTiffany: [colorMap.Black, colorMap.Lips, colorMap.Tiffany],
  DarkGreyPonyTiffany: [colorMap.DarkGrey, colorMap.Pony, colorMap.Tiffany],
  DarkGreyLavenderPony: [
    colorMap.DarkGrey,
    colorMap.Lavender,
    colorMap.Tiffany,
  ],
};
